import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserEmailModelOutput } from 'infrastructure/graphql/content/user/model/user-email-model.output';
import { UserEmailModel } from 'user/user-email-model';

@Injectable({ providedIn: 'root' })
export class UserEmailModelConverterService {
	public userEmailModelAsEntity(output: UserEmailModelOutput): UserEmailModel {
		if (!output) {
			return null;
		}

		return new UserEmailModel(
			output.id,
			output.name,
			output.body,
			output.userId,
			output.subject
		);
	}

	public userEmailModelsAsEntities(
		outputs: UserEmailModelOutput[]
	): UserEmailModel[] {
		return reject(outputs, isNil).map((output) =>
			this.userEmailModelAsEntity(output)
		);
	}
}
